import { Component, ViewChild, ViewContainerRef, ComponentRef, Input } from '@angular/core';

@Component({
    selector: 'app-modal',
    template: `
    <dialog id="dialog">
    <div class="modal" tabindex="-1" role="dialog" aria-hidden="true">
      <button (click)="close()" id="dialog_close">Close</button>
      <ng-container #dynamicContent></ng-container>
      </div>
		</dialog>
  `,
    styleUrls: ['./modal.component.scss'],
    standalone: false
})
export class ModalComponent {
  @ViewChild('dynamicContent', { read: ViewContainerRef }) container!: ViewContainerRef;
  @Input() relatedData!: { [key: string]: any };

  loadComponent(component: any): ComponentRef<any> {
    // lock the viewport
    document.body.style.overflow = 'hidden';

    this.container.clear();
    const componentRef = this.container.createComponent(component);

    // pass relatedData along
    for (const key in this.relatedData) {
      (componentRef.instance as any)[key] = this.relatedData[key];
    }

    return componentRef;
  }

  ngOnDestroy() {
    this.close();
  }

  close() {
    document.body.style.overflow = 'auto';
  }
}